import React, { useRef } from 'react';
import cn from 'clsx';
import { Button, LinkWithGAPromoClick, SectionTitle, Typography } from 'common/components';
import { usePromoViewEvent } from 'common/hooks';
import { ACCESSORIES_ELEMENT_BLOCK_NAME, PROMOTION_LIST } from './accessories-section-constants';
import {
  accessoriesLinkItem,
  accessoriesList,
  basketsAndAccessories,
  basketsAndAccessoriesImage,
  basketsAndAccessoriesName,
  sectionName,
  shelves,
  shelvesImage,
  shelvesName,
  storageBoxes,
  storageBoxesDescription,
  storageBoxesItem,
  storageBoxesName,
  storageBoxesSeeButton,
} from './accessories-section-styles';

/**
 * Вью секции Аксессуары и комплектующие
 */
export const AccessoriesSection = () => {
  const refs = useRef<HTMLAnchorElement[]>([]);

  usePromoViewEvent(refs, ACCESSORIES_ELEMENT_BLOCK_NAME, PROMOTION_LIST);

  return (
    <section>
      <SectionTitle className={sectionName}>Аксессуары и&nbsp;комплектующие</SectionTitle>
      <ul className={accessoriesList}>
        <li>
          <LinkWithGAPromoClick
            bannerRefs={refs}
            className={cn(accessoriesLinkItem, basketsAndAccessories)}
            elementBlock={ACCESSORIES_ELEMENT_BLOCK_NAME}
            href="/catalogue/stellazhi-dlya-doma/korziny-i-aksessuary-spaceo-kub/"
            position={0}
            promotion={PROMOTION_LIST[0]}
            title="Корзины и акксессуары">
            <img
              className={basketsAndAccessoriesImage}
              src="https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_90,c_pad,b_auto,d_photoiscoming.png/fudzi/elbrus/images/landings/spaceo-storage/accessories/1.png/1.png"
              alt="Корзины и акксессуары"
              title="Корзины и акксессуары"
            />
            <Typography as="h3" variant="h3" className={basketsAndAccessoriesName}>
              Корзины и&nbsp;акксессуары
            </Typography>
          </LinkWithGAPromoClick>
        </li>

        <li className={storageBoxesItem}>
          <LinkWithGAPromoClick
            bannerRefs={refs}
            className={cn(accessoriesLinkItem, storageBoxes)}
            elementBlock={ACCESSORIES_ELEMENT_BLOCK_NAME}
            href="/catalogue/koroba-dlya-hraneniya/spaceo/"
            position={1}
            promotion={PROMOTION_LIST[1]}
            title="Короба для хранения">
            <Typography as="h3" variant="h2" className={storageBoxesName}>
              Короба для хранения
            </Typography>
            <Typography variant="m" size="body_long" className={storageBoxesDescription}>
              Более 10&nbsp;цветов
            </Typography>
            <Button variant="outline" className={storageBoxesSeeButton}>
              Посмотреть
            </Button>
          </LinkWithGAPromoClick>
        </li>

        <li>
          <LinkWithGAPromoClick
            bannerRefs={refs}
            className={cn(accessoriesLinkItem, shelves)}
            elementBlock={ACCESSORIES_ELEMENT_BLOCK_NAME}
            href="/catalogue/stellazhi-dlya-doma/polki-fasady-i-vydvizhnye-yashchiki-spaceo-kub/"
            position={2}
            promotion={PROMOTION_LIST[2]}
            title="Полки, фасады и выдвижные ящики">
            <img
              className={shelvesImage}
              src="https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_90,c_pad,b_auto,d_photoiscoming.png/fudzi/elbrus/images/landings/spaceo-storage/accessories/3.png/3.png"
              alt="Полки, фасады и выдвижные ящики"
              title="Полки, фасады и выдвижные ящики"
              width="180"
              height="195"
              loading="lazy"
            />
            <Typography as="h3" variant="h3" className={shelvesName}>
              Полки, фасады и&nbsp;выдвижные ящики
            </Typography>
          </LinkWithGAPromoClick>
        </li>
      </ul>
    </section>
  );
};
